import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import * as constant from "./constant";
import { processCommonError, processUnhandleDrejection } from "./processError";
import requestIdleCallback from "./requestIdleCallback";
import { watchPageVisibilityChange } from "./visibility-change";
var hasOwnProperty = Object.prototype.hasOwnProperty;
export var shadowMerge = function(target, source) {
    for(var key in source){
        if (hasOwnProperty.call(source, key)) {
            // eslint-disable-next-line no-param-reassign
            target[key] = source[key];
        }
    }
    return target;
};
/**
 * 获取16进制的随机数
 * @param len 返回长度
 * @param radix 转换进制
 */ export function getRandomNum() {
    var len = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, radix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16;
    var val = [];
    for(var i = 0; i < len; i++){
        var r = Math.floor(Math.random() * radix);
        val[i] = r.toString(radix);
    }
    return val.join("");
}
/**
 * 生成uuid
 */ export function uuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        var v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
/**
 * 省略开头为 ? #的特殊字符
 * @param str
 */ export var ignoreFirstSpecialChar = function(str) {
    return typeof str === "string" ? str.replace(/^\?|#/, "") : "";
};
export var checkWin = function() {
    return !!(typeof window === "object" && window.document);
};
export var cleanUrl = function(url) {
    var spaRouteType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "history";
    if (typeof url !== "string" || url.trim() === "" || url.indexOf("http") !== 0) {
        return url;
    }
    var fixUrl = url.trim();
    try {
        var urlObj = new URL(fixUrl);
        if (spaRouteType === "hash") {
            fixUrl = urlObj.origin + urlObj.pathname + urlObj.hash.replace(/(#[^'"[?{%=:]+).*/, "$1");
        } else {
            fixUrl = urlObj.origin + urlObj.pathname;
        }
    } catch (e) {
    // ignore
    }
    return fixUrl;
};
/**
 * 获取url
 */ export var getUrl = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var isWin = checkWin();
    var _config_ignoredQueries = config.ignoredQueries, ignoredQueries = _config_ignoredQueries === void 0 ? [] : _config_ignoredQueries, getUrlFn = config.getUrl, spaRouteType = config.spaRouteType;
    if (typeof getUrlFn === "function") {
        return getUrlFn();
    } else if (isWin) {
        return handleIgnoreQueries(cleanUrl(window.location.href, spaRouteType), ignoredQueries);
    }
    return "";
};
/**
 * 获取origin url
 */ export var getOriginUrl = function() {
    var isWin = checkWin();
    return isWin ? window.location.href : "";
};
/**
 * 获取hash
 */ export var getUrlHash = function() {
    var isWin = checkWin();
    return isWin ? ignoreFirstSpecialChar(window.location.hash) : "";
};
/**
 * 获取url query
 */ export var getUrlQuery = function() {
    var isWin = checkWin();
    return isWin ? ignoreFirstSpecialChar(window.location.search) : "";
};
/**
 * 获取spm ab
 */ export var getSpmAB = function() {
    var _goldlog, _goldlog1;
    var isWin = checkWin();
    if (!isWin) {
        return {
            a: "",
            b: ""
        };
    }
    var goldlog = window.goldlog;
    var spm_ab = ((_goldlog = goldlog) === null || _goldlog === void 0 ? void 0 : _goldlog.spm_ab) || ((_goldlog1 = goldlog) === null || _goldlog1 === void 0 ? void 0 : _goldlog1.spmAb) || [];
    return {
        a: spm_ab[0] || "",
        b: spm_ab[1] || ""
    };
};
/**
 * 将object转成key=value&key1=value1的形式
 * @param values
 */ export var toQueryParams = function(values) {
    var usePost = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var strValArr = [];
    for(var key in values){
        if (Object.prototype.hasOwnProperty.call(values, key)) {
            var value = values[key];
            var valueStr = value;
            if (typeof value === "object") {
                if (value === null) {
                    valueStr = "";
                } else {
                    valueStr = JSON.stringify(value);
                }
            }
            var strValue = "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(usePost ? encodeURIComponent(valueStr) : String(valueStr).slice(0, constant.VALUE_LIMIT)));
            strValArr.push(strValue);
        }
    }
    return strValArr.join("&");
};
export var queryToObj = function(str) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "&";
    var obj = {};
    var arr = str.split(separator);
    arr.forEach(function(item) {
        var keyValueArr = item.split("=");
        var key = keyValueArr[0];
        obj[key] = keyValueArr[1];
    });
    return obj;
};
/**
 * 事件绑定
 * @param  {DOM}   target
 * @param  {String}   type
 * @param  {Function} callback
 * @param  {Boolean}  isOnce
 * @param  {Boolean} useCapture
 * @return {Object} this
 */ export function on(target, type, callback, isOnce, useCapture) {
    if (target.addEventListener) {
        useCapture = useCapture || false;
        target.addEventListener(type, function __fn(e) {
            isOnce && target.removeEventListener(type, __fn, useCapture);
            callback.call(this, e);
        }, useCapture);
    } else if (target.attachEvent) {
        target.attachEvent("on".concat(type), function __fn(e) {
            isOnce && target.detachEvent("on".concat(type), __fn);
            callback.call(this, e);
        });
    }
    return this;
}
export function bindEvent(target, type, callback, isOnce, useCapture) {
    var emptyFn = function() {};
    if (!target) {
        return emptyFn;
    }
    if (target.addEventListener) {
        var __fn = function __fn1(e) {
            isOnce && target.removeEventListener(type, __fn, useCapture);
            callback.call(this, e);
        };
        useCapture = useCapture || false;
        target.addEventListener(type, __fn, useCapture);
        return function() {
            target.removeEventListener(type, __fn, useCapture);
        };
    } else if (target.attachEvent) {
        var __fn1 = function __fn(e) {
            isOnce && target.detachEvent("on".concat(type), __fn1);
            callback.call(this, e);
        };
        target.attachEvent("on".concat(type), __fn1);
        return function() {
            target.detachEvent("on".concat(type), __fn1);
        };
    }
    return emptyFn;
}
export function getSendInfo(type, aplusHost) {
    var host = aplusHost && typeof aplusHost === "string" ? aplusHost : constant.APLUS_HOST;
    var APLUS_LOGKEY = type === "perf" ? constant.PREF_APLUS_LOGKEY : constant.APLUS_LOGKEY;
    var APLUS_URL = "https://".concat(host).concat(APLUS_LOGKEY);
    return {
        APLUS_LOGKEY: APLUS_LOGKEY,
        APLUS_URL: APLUS_URL
    };
}
export var getXPath = function(dom, depth) {
    var id = dom.id ? "#".concat(dom.id) : "";
    var className = dom.className && dom.className.split ? ".".concat(dom.className.split(" ").join(".")) : "";
    var tagName = dom.tagName ? dom.tagName.toLowerCase() : "";
    if (dom.parentNode && dom.parentNode.tagName && depth - 1 !== 0) {
        return "".concat(getXPath(dom.parentNode, depth - 1), " > ").concat(tagName.toLowerCase()).concat(id).concat(className);
    }
    return tagName + id + className;
};
export var getWin = function() {
    return typeof window === "object" && window.document ? window : undefined;
};
/**
 * 获取灰度数据
 */ export var getPageMetaConfig = function() {
    var isWin = checkWin();
    var obj = {};
    try {
        if (isWin) {
            var pageMetaDom = window.document.querySelector('meta[name="page-tag"]');
            if (pageMetaDom) {
                var content = pageMetaDom.getAttribute("content") || "";
                return queryToObj(content, ",");
            }
        }
        return obj;
    } catch (e) {
        return {};
    }
};
export var genRandomIp = function() {
    var str = [];
    for(var i = 0; i < 4; i++){
        var r = Math.floor(Math.random() * 256);
        str[i] = (r > 15 ? "" : "0") + r.toString(16);
    }
    return str.join("");
};
/**
 * 生成traceId
 * IPV4(8位) + 毫秒时间(13位) + 顺序数(4位) + 标志位(1位) + pid(4位)
 * 参考 http://aligitlab.oss-cn-hangzhou-zmf.aliyuncs.com/uploads/middleware/eagleeye-docs/a5013cea9e64f2ebb1076cab60137d4b/traceid.png
 */ export var genTraceId = function() {
    var INIT_RECORD = 1000;
    var record = INIT_RECORD;
    return function() {
        // 模拟8位 IPV4
        var a = genRandomIp();
        // 毫秒时间(13位)
        var b = Date.now();
        // 顺序数 1000以上
        var c = record;
        // 标志位
        var d = getRandomNum(1);
        // pid
        var e = getRandomNum(4);
        record = record + 1 > 10000 ? INIT_RECORD : record + 1;
        return a + b + c + d + e;
    };
}();
/**
 * 采样率处理
 */ export var checkSample = function(rate) {
    return rate > Math.random();
};
/**
 * error解析
 */ export var processError = function(e) {
    var data = {};
    if (typeof PromiseRejectionEvent !== "undefined" && _instanceof(e, PromiseRejectionEvent)) {
        data = processUnhandleDrejection(e) || {};
    } else {
        data = processCommonError(e) || {};
    }
    return data;
};
function isArray(arr) {
    return ({}).toString.call(arr) === "[object Array]";
}
var parseQuery = function parseQuery(str) {
    var ret = {};
    if (typeof str !== "string") {
        return ret;
    }
    str = str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "").replace(/^(\?|#|&)/, "");
    if (!str) {
        return ret;
    }
    var arr = str.split("&");
    for(var i = 0; i < arr.length; ++i){
        var param = arr[i];
        var parts = param.replace(/\+/g, " ").split("=");
        var key = parts.shift() || "";
        var val = parts.length > 0 ? parts.join("=") : "";
        // key = decodeURIComponent(key);
        // val = decodeURIComponent(val);
        if (!ret[key]) {
            ret[key] = val;
        } else if (isArray(ret[key])) {
            ret[key].push(val);
        } else {
            ret[key] = [
                ret[key],
                val
            ];
        }
    }
    return ret;
};
var VALUE_LIMIT = 512;
var stringifyQuery = function stringifyQuery(obj, ignoredQueries) {
    if (!obj) {
        return "";
    }
    var curIgnoredQueries = ignoredQueries || [];
    var keys = [];
    for(var key in obj){
        if (hasOwnProperty.call(obj, key)) {
            keys.push(key);
        }
    }
    var arr = [];
    keys = keys.sort();
    for(var j = 0; j < keys.length; ++j){
        var key1 = keys[j];
        var val = obj[key1];
        var found = false;
        for(var k = 0; k < curIgnoredQueries.length; ++k){
            if (curIgnoredQueries[k] === key1) {
                found = true;
                break;
            }
        }
        if (found) {
            continue;
        }
        if (!val) {
            arr.push(key1);
            continue;
        }
        arr.push("".concat(key1, "=").concat(String(val).slice(0, VALUE_LIMIT)));
    }
    return arr.join("&");
};
var handleIgnoreQueries = function(url, ignoredQueries) {
    var _ignoredQueries, _url, _url1, _url2;
    if (!url) {
        return "";
    }
    // 未设置 ignoredQueries 时，不需要进行转换
    if (!((_ignoredQueries = ignoredQueries) === null || _ignoredQueries === void 0 ? void 0 : _ignoredQueries.length)) {
        return url;
    }
    var _url_split = _sliced_to_array(url.split("?"), 2), pathName = _url_split[0], pathQuery = _url_split[1];
    var splitCode = "?";
    if (((_url = url) === null || _url === void 0 ? void 0 : _url.indexOf("?")) === -1 && ((_url1 = url) === null || _url1 === void 0 ? void 0 : _url1.indexOf("http")) !== -1) {
        return url;
    }
    if (((_url2 = url) === null || _url2 === void 0 ? void 0 : _url2.indexOf("?")) === -1) {
        pathName = "";
        pathQuery = url;
        splitCode = "";
    }
    return "".concat(pathName).concat(splitCode).concat(stringifyQuery(parseQuery(pathQuery), ignoredQueries));
};
var previousPageUrl = "";
var processedReferrer = "";
export var getCommonInfo = function(ignoredQueries, config) {
    var win = getWin();
    var commonInfo = {};
    // 补充判断web环境
    if (win && "onload" in win) {
        var referrer = document.referrer;
        if (!processedReferrer && !previousPageUrl) {
            // js初始化加载
            processedReferrer = referrer;
        } else if (referrer !== previousPageUrl && previousPageUrl && previousPageUrl !== location.href) {
            // 变更过 URL
            processedReferrer = previousPageUrl;
        }
        // 进入页面之后没有变更过URL  processedReferrer不做处理
        previousPageUrl = location.href;
        var navigator = win.navigator || {};
        var connection = navigator.connection || {};
        commonInfo.url = getUrl(config);
        commonInfo.origin_url = handleIgnoreQueries(getOriginUrl(), ignoredQueries);
        commonInfo.referrer = handleIgnoreQueries(processedReferrer, ignoredQueries);
        commonInfo.title = config.title || document.title;
        commonInfo.hash = getUrlHash();
        commonInfo.query = handleIgnoreQueries(getUrlQuery(), ignoredQueries);
        commonInfo.dpr = win.devicePixelRatio || 1; // 屏幕像素比
        commonInfo.sr = typeof screen === "object" && "".concat(screen.width, "x").concat(screen.height) || ""; // 分辨率
        commonInfo.net_type = connection.effectiveType || connection.type || ""; // 网络制式
    }
    return commonInfo;
};
export function hookHistory(onChange) {
    var win = checkWin() ? window : {};
    var onHistoryChange = onChange;
    var handleHistoryChange = function() {
        if (typeof onHistoryChange === "function") {
            onHistoryChange();
        }
    };
    try {
        // hook onpopstate
        var oldPopstate = win.onpopstate;
        win.onpopstate = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (typeof oldPopstate === "function") {
                // @ts-ignore 无需关注
                return oldPopstate.apply(this, args);
            }
            handleHistoryChange();
        };
        // hook pushState
        if (win.history && typeof win.history.pushState === "function") {
            var oldPushState = win.history.pushState;
            var newPushState = function newPushState() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                // @ts-ignore 无需关注
                oldPushState.apply(this, args);
                handleHistoryChange();
            };
            win.history.pushState = newPushState;
        }
        // hook replaceState
        if (win.history && typeof win.history.replaceState === "function") {
            var oldReplaceState = win.history.replaceState;
            var newReplaceState = function newReplaceState() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                // @ts-ignore 无需关注
                oldReplaceState.apply(this, args);
                handleHistoryChange();
            };
            win.history.replaceState = newReplaceState;
        }
    } catch (error) {
        console.warn("[cone-arms] error in hookHistory", error);
    }
    return function() {
        onHistoryChange = null;
    };
}
/**
 * 绑定 hashchange 或移除
 * @private
 * @param  {Boolean} isBind
 */ export var hookHashChange = function hookHashChange(onChange) {
    var win = checkWin() ? window : {};
    if (!(win && win.location)) {
        return function() {};
    }
    // NOTE 如果手动改了地址栏的 hash，不会触发刷新，会触发 hashchange ，同时还会优先触发 beforeunload
    var unhook = bindEvent(win, "hashchange", onChange);
    return function() {
        if (unhook && typeof unhook === "function") unhook();
    };
};
/**
 * 检测是否支持监控某种变化类型
 * @param entryType
 * @returns
 */ export var supportedEntryType = function(entryType) {
    return checkWin() && typeof PerformanceObserver === "function" && Array.isArray(PerformanceObserver.supportedEntryTypes) && PerformanceObserver.supportedEntryTypes.indexOf(entryType) > -1;
};
export function isUSTimezone(timezone_area) {
    return constant.US_TIMEZONES.includes(timezone_area);
}
export var shouldSkipUSIPReport = function(config, clientExtraInfo) {
    var _clientExtraInfo;
    if (config.allowUSIPReport) return false;
    // 检查时区
    if (((_clientExtraInfo = clientExtraInfo) === null || _clientExtraInfo === void 0 ? void 0 : _clientExtraInfo.timezone_area) && isUSTimezone(clientExtraInfo.timezone_area)) {
        return true;
    }
    return false;
};
export { requestIdleCallback, watchPageVisibilityChange };
export default {
    shadowMerge: shadowMerge,
    getRandomNum: getRandomNum,
    uuid: uuid,
    ignoreFirstSpecialChar: ignoreFirstSpecialChar,
    checkWin: checkWin,
    cleanUrl: cleanUrl,
    getUrl: getUrl,
    getOriginUrl: getOriginUrl,
    getUrlHash: getUrlHash,
    getUrlQuery: getUrlQuery,
    getSpmAB: getSpmAB,
    toQueryParams: toQueryParams,
    queryToObj: queryToObj,
    on: on,
    bindEvent: bindEvent,
    getSendInfo: getSendInfo,
    getXPath: getXPath,
    getWin: getWin,
    getPageMetaConfig: getPageMetaConfig,
    genRandomIp: genRandomIp,
    genTraceId: genTraceId,
    checkSample: checkSample,
    processError: processError,
    getCommonInfo: getCommonInfo,
    hookHistory: hookHistory,
    hookHashChange: hookHashChange,
    requestIdleCallback: requestIdleCallback,
    watchPageVisibilityChange: watchPageVisibilityChange,
    supportedEntryType: supportedEntryType
};

 //# sourceMappingURL=index.js.map